<template>
     <div id="myFollowModal" class="overlay fade-in-overlay">
       <div class="newModal">
              <!-- Button to close the overlay navigation -->
              <a href="javascript:void(0)" class="closebtn" v-on:click="closeFollowModal();">&times;</a>
              <!-- Overlay content -->
              <div class="overlay-content">
                <div class="content-image"><img src="static/assets/images/dwerve_follow.jpeg" alt=""></div>
              <div class="col-xs-12">
                <div data-aos="fade-right">
                  <h2 class="follow-title">Suscribe to our newsletter!</h2>
                  <h4 class="follow-subtitle">You will be entered for a chance to win alpha access!</h4>
               
                   <div id="mc_embed_signup">
        
                  <form action="https://halfhumangames.us20.list-manage.com/subscribe/post?u=0137a8236f6ae6db0a6cc9b2b&amp;id=e0b4502ce9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                      <div id="mc_embed_signup_scroll">
                      
                  <div class="mc-field-group">
                      
                      <input type="email" value="" placeholder="Enter email here" name="EMAIL" class="required email" id="mce-EMAIL">
                  </div>
                      <div id="mce-responses" class="clear">
                          <div class="response" id="mce-error-response" style="display:none"></div>
                          <div class="response" id="mce-success-response" style="display:none"></div>
                      </div>    
                      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_0137a8236f6ae6db0a6cc9b2b_e0b4502ce9" tabindex="-1" value=""></div>
                      <div class="clear"><input type="image" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button animated pulse animated-infinite" src="/static/assets/images/Subscribe.png"></div>
                      </div>
                  </form>
                  </div>
                </div>
                
                </div>
              </div>
              </div>
          </div>
</template>

<script>

export default {
  data: function() {
    return {};
  },
  methods: {
    openFollowModal() {
      document.getElementById("myFollowModal").style.display = "block";
    },
    closeFollowModal() {
      document.getElementById("myFollowModal").style.display = "none";
     
     //document.getElementById("navbar").style.zIndex = "2 !important";
    },
    setZIndex2(){
      //document.getElementById("navbar").style.zIndex = "2 !important";
    },
    onScrollOpen(){
      $(window).scroll(function() {
        var self = this;
        
        if($(window).scrollTop() + $(window).height() > $(document).height() - 2000) {
          var cookie = localStorage.getItem('popup');

          if(cookie === null){
            document.getElementById("myFollowModal").style.display = "block";
            localStorage.setItem('popup', 'PopupCookie');
          }
        }
        });
    }
  },
  mounted() {
      this.onScrollOpen();
  }
};
</script>

<style scoped>
iframe {
    width: 100%;
    height: 400px;
}
.overlay-content .col-xs-12 {
    padding-top: 250px;
    letter-spacing: normal;
    clear: both;
    width: 100%;
    padding: 250px 30px 30px;
    margin-left: auto;
    margin-right: auto;
}
.overlay-content .col-xs-12 form#mc-embedded-subscribe-form {
    padding: 0;
}
.overlay-content div#mc_embed_signup .clear input#mc-embedded-subscribe {
    background: transparent !important;
    width: 127px !important;
    height: auto !important;
    float: right;
    padding: 0 !important;
}
.overlay-content div#mc_embed_signup {
    top: 0 !important;
}
.overlay-content div#mc_embed_signup .clear input#mc-embedded-subscribe {
    float: inherit;
}
.overlay-content .mc-field-group {
    width: 100% !important;
}
.overlay-content div#mc_embed_signup input#mce-EMAIL {
    width: 100% !important;
        border: 2px solid rgba(0, 0, 0, 0.39);
    background: white;
}
.overlay-content div#mc_embed_signup .clear {
    width: 100% !important;
    left: 0;
    top: 0;
    margin-left: -49%;
}
.overlay-content p.follow-subtitle2 {
    font-family: Digitalt;
    font-size: 18px !important;
    color: #59595B !important;
    text-shadow: none;
    text-align: left;
}
a.closebtn {
    width: 30px;
    font-weight: 900;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    height: 30px;
    background-color: #fff;
    border-radius: 100%;
    -webkit-box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.2);
    cursor: pointer;
    position: absolute;
    right: -10px;
    top: -10px;
    font-size: 17px;
    z-index: 2;
    text-shadow: none;
    color: black;
}
div#myFollowModal {
    z-index: 9999;
    position: fixed;
    top: 15%;
    bottom: 60px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    min-height: 330px;
    max-height: 545px;
    display: none;
    box-shadow: 37px 65px 118px 800px rgba(0, 0, 0, 0.6);
    max-width: 490px;
    background: transparent;
}
@font-face {
  font-family: Digitalt;
  font-display: swap;
  src: url(/static/assets/lib/Digitalt.otf);
}
.follow-title {
  font-family: Digitalt;
  color: #595959;
    font-size: 32px;
    text-shadow: none;
    text-align: left;
    letter-spacing: normal;
}
.follow-subtitle {
  font-family: Grandmaster;
    font-size: 16px;
    color: #595959;
    text-shadow: none;
    text-align: left;
    text-transform: initial;
}
.follow-subtitle2 {
  font-family: Digitalt;
  font-size: 23px;
  color: #febf45;
  margin: 0 0 0px;
  line-height: 1;
  font-weight: 100;
  padding-top: 0px;
}
.slice-tower,
.game-title .crossbow {
  min-width: unset;
  width: unset;
  max-width: unset;
  min-height: unset;
  height: unset;
  margin: 0 auto;
}

.follow-btn {
  width: 402px;
}

.crossbow {
  position: absolute;
  object-fit: contain;
  left: unset;
  bottom: unset;
  min-width: unset;
  min-height: unset;
}

.slice-tower {
  position: absolute;
  left: unset;
  object-fit: contain;
  bottom: unset;
}

.subtitle-img {
  z-index: 9;
  left: 19%;
  top: 2%;
  position: absolute;
}
.newModal {
        position: fixed;
        border-radius: 6px;
    z-index: 9999;
    height: 545px;
        max-width: 490px;
    background: #fff;
}
.mc-closeModal:before, .mc-closeModal:after {
    background-color: #414141;
    content: '';
    position: absolute;
    left: 14px;
    height: 14px;
    top: 8px;
    width: 2px;
}
.overlay:before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    z-index: 1;
    background-color: transparent;
}
.fade-in.three {
  -webkit-animation-delay: 2.6s;
  -moz-animation-delay: 2.6s;
  animation-delay: 2.6s;
}

.fade-in {
  opacity: 0; /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.follow::before,
.follow::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.follow {
  position: absolute;
  top: 93%;
  left: 51%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.suscribe {
  margin-left: 50%;
  margin-top: 48%;
  transform: translateZ(600px);
}

.parallax {
  position: relative;
  width: 100%;
  height: 800px;
  left: 0;
}

.cd-floating-background {
  position: absolute;
  right: 0;
}
.cd-background-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  position: relative;
}

.dwerveTitle {
  position: absolute;
  margin: auto;
  object-fit: cover;
  object-position: 50% 100% !important;
  height: auto !important;
  bottom: 0;
  width: 57% !important;
  left: 3% !important;
  min-width: unset;
  min-height: unset;
}

.background {
  position: absolute;
  z-index: -1;
  min-width: unset;
  margin: auto;
  width: 100% !important;
  min-width: unset;
  min-height: unset;
  top: unset;
  bottom: unset;
  object-fit: cover;
  object-position: 100% 100% !important;
}

@media (min-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    height: auto;
    margin-top: 0;
    object-position: 95.83% 100%;
  }
  .dwerveTitle {
    bottom: 0;
    top: 33% !important;
    margin-top: auto !important;
  }
  .follow {
    top: 90%;
  }
  .background {
    height: auto;
  }
}

@media (max-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    object-position: 95.83% 100%;
  }
  .dwerveTitle {
    bottom: 0;
    top: 39% !important;
  }
  .follow {
    top: 87%;
  }
  .background {
    height: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .dwerveTitle {
    width: 80% !important;
    margin-bottom: 30%;
    left: -11% !important;
  }
  .follow {
    font-size: 5vw;
  }
  .slice-tower {
    display: none;
  }
}
@media only screen and (min-width: 500px) and (max-width: 600px) {
  .dwerveTitle {
    width: 85% !important;
    margin-bottom: 19%;
    left: -2% !important;
  }
  .follow {
    font-size: 3vw;
    top: 81%;
  }
}
@media only screen and (min-width: 600px) and (max-width: 800px) {
  .dwerveTitle {
    width: 83% !important;
    top: 40% !important;
    left: -4% !important;
  }
  .follow {
    font-size: 3vw;
    top: 90%;
  }
}
@media only screen and (min-width: 800px) and (max-width: 900px) {
  .dwerveTitle {
    width: 85% !important;
    top: 59% !important;
    left: 0% !important;
  }
  .follow {
    font-size: 3vw;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1100px) {
  .dwerveTitle {
    width: 74% !important;
    top: 39% !important;
    left: 0% !important;
  }
  .follow {
    font-size: 2.6vw;
  }
}
@media only screen and (width: 1024) {
  .dwerveTitle {
    width: 70% !important;
    margin-bottom: 21%;
    left: 16% !important;
  }
}

@media (width: 375px) {
  .dwerveTitle {
    margin-bottom: 27%;
  }
}

.spider-hanging {
  position: absolute;
  top: -115%;
  width: 15%;
}
.overlay {
  /* Height & width depends on how you want to reveal the overlay (see JS below) */
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  display: none;
  background-color: rgb(0, 0, 0); /* Black fallback color */
  background-color: #0d182de6; /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}



/* The navigation links inside the overlay */

.overlay-content input#semail {
  height: 69px;
}
.content-image img {
    position: absolute;
    top: 0;
    display: block;
    clear: both;
     min-height: 250px;
    width: 100%;
    background-position: 50% 50%;
    background-size: 50% auto;
    object-fit: cover;
    background-repeat: no-repeat;
    border-top-left-radius: 6px;
}

/* When you mouse over the navigation links, change their color */
.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

/* Position the close button (top right corner) */


/* When the height of the screen is less than 450 pixels, change the font-size of the links and position the close button again, so they don't overlap */
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.follow-form {
  padding-top: 0px;
  width: 53%;
  margin-left: 24%;
}
.fade-in-overlay {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
#heroheader .col-xs-12 {
  clear: both;
    width: 100%;
    padding: 250px 30px 30px;
    margin-left: auto;
    margin-right: auto;
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }
}
/* Mailtrain styles */
#heroheader .form-group.email label {
  display: none;
}
#heroheader .form-group {
  display: inline-block;
}

#heroheader .form-group.email input {
  top: -9px;
  left: 6px;
}
#heroheader .form-group.email label {
  display: none;
}
/* div#mailtrain-subscription-widget-rJfit7pAM h3 {
  display: none;
} */
#heroheader .mailtrain-subscription-widget h3 {
  display: none;
}
h3.cta-title {
  display: block;
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  #heroheader form.form button {
    font-size: 19px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  .cta-subtitle {
    padding-top: 32px;
  }
  .follow-title {
    font-size: 26px;
  }
  .follow-subtitle {
    font-size: 14px;
  }
  .follow-subtitle2 {
    font-size: 18px !important;
    padding-top: 0px;
  }
  .overlay-content div#mc_embed_signup {
    top: 0;
}
.overlay-content #mc_embed_signup .clear {
    top: -56px;
    left: 34px;
}
.overlay-content #mc_embed_signup .mc-field-group {
    left: -32px;
}
.overlay-content div#mc_embed_signup {
    top: -16px;
    max-width: 356px;
}

}
</style>


// WEBPACK FOOTER //
// src/views/Home/FollowModal.vue